import React, { useState, useEffect } from 'react'
import s from '../CreateQuiz.module.scss'
import { Divider } from '@material-ui/core';

export const SideMenu = ({
    questionNumber,
    openDropDown,
    setQuizTitle,
    quiz,
    highestQuestionNumber,
    setCurrQuestion,
    goToStep,
    goToMainQuizPage,
}) => {
    const [showDropDownItems, setShowDropDownItems] = useState([]);
    useEffect(() => {
        if (openDropDown && !showDropDownItems[questionNumber - 1]) {
            dropDown()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openDropDown])

    function dropDown(e) {
        if (e) { e.stopPropagation() }

        const newArr = showDropDownItems.map(() => {
            return false
        })
        const indexToToggle = e?.target.dataset.value || e?.target.value || JSON.stringify(questionNumber - 1);
        if (!indexToToggle) {
            return;
        }
        if (newArr.length === JSON.parse(indexToToggle)) {
            newArr.push(true);
        } else {
            newArr[indexToToggle] = !showDropDownItems[indexToToggle];
        }
        setCurrQuestion(indexToToggle)
        setShowDropDownItems([...newArr]);
    }
    const steps = [
        {
            title: 'Questions',
            questionStep: 1
        },
        {
            title: 'Products',
            questionStep: 2
        },
        {
            title: 'Price',
            questionStep: 3
        },
        {
            title: 'Settings',
            questionStep: 4
        },
    ]
    return (
        <div className={s.sideMenu} style={{ borderRight: '1px solid #0000001a' }}>
            <h1 className="mt-8 mb-5">Create a new quiz</h1>
            <input onInput={setQuizTitle} defaultValue={quiz.title} type="email" className="form-control form-control-solid" placeholder="Type your quiz name.." />
            <Divider className="my-7" />
            {steps.map((step, index) =>
                <div key={step.title}
                    onClick={goToStep}
                    data={`${step.questionStep}`}
                    className={`${s.sideMenuStep} ${highestQuestionNumber >= step.questionStep ? '' : s.disabledMenuStep}`}
                >
                    <div data={`${step.questionStep}`} className={`${s.sideMenuNumber} ${questionNumber === step.questionStep ? s.currentStep : ''}`}>
                        <span data={`${step.questionStep}`}>
                            {index + 1}
                        </span>
                    </div>
                    <span className={s.sideMenuTitle}>
                        {step.title}
                    </span>
                </div>
            )}
            <Divider className="my-7" />
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
            }}>
                <button onClick={() => goToMainQuizPage()} type="button" className="btn btn-dark">Keep Changes</button>
                <button onClick={() => goToMainQuizPage()} type="button" className="btn btn-outline-dark">Discard Changes</button>
            </div>
        </div >
    )
}
